module.exports = __webpack_public_path__ + "img/play.59fb5cbb.svg";